import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { ReactComponent as DownloadSVG } from 'shared/img/download.svg'

import { downloadingAppLink } from 'shared/constants'

import { selectLocaleDict } from 'features/locale/selectors'

import Button from 'components/UIKit/Button/Button'

import './DownloadAppButton.scss'

const b = block('download-app-button')

export const DownloadAppButton = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const onDownloadClick = useCallback(() => {
    location.href = downloadingAppLink
  }, [])

  return (
    <div className={b()}>
      <Button icon={{ svg: DownloadSVG }} callback={onDownloadClick} text={locale.downloadApk} />
    </div>
  )
}
